import { useEffect, useMemo } from 'react';
import { AbortableFetch } from '../../store/fetch';

export function useAbortableFetch() {
    const abortableFetch = useMemo(() => new AbortableFetch(), []);

    useEffect(() => {
        return () => abortableFetch.abort();
    }, []);

    return abortableFetch;
}
